/** Chooses the data provider and auth adapter from VITE_DATA_MODE. This is the only place that knows which one runs. */
import { env } from '@/config/env';
import { ApiAuthAdapter, MockAuthAdapter, type AuthAdapter } from '@/auth/authAdapter';
import { ApiDataProvider } from '@/providers/api/ApiDataProvider';
import { HttpClient } from '@/providers/api/httpClient';
import { MockDataProvider, mockOptionsFromUrl } from '@/providers/mock/MockDataProvider';
import type { DataProvider } from './DataProvider';

export function createAuthAdapter(): AuthAdapter {
  return env.dataMode === 'api' ? new ApiAuthAdapter(env.apiBaseUrl) : new MockAuthAdapter();
}

export function createDataProvider(auth: AuthAdapter): DataProvider {
  if (env.dataMode === 'api') {
    return new ApiDataProvider({
      client: new HttpClient({ baseUrl: env.apiBaseUrl, getToken: () => auth.getAccessToken() }),
      serverAnalytics: env.serverAnalytics,
    });
  }
  return new MockDataProvider(mockOptionsFromUrl());
}

export { createServices, type Services } from './services';
export { DataError, type DataProvider } from './DataProvider';
